import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { RoutesService } from '../../services/routes.service';
import { RouteService } from '../../services/route.service';
import { RateService } from '../../services/rate.service';
import { CommonService } from '../../services/common.service';
import { Observable } from 'rxjs/Observable';
import { any } from "codelyzer/util/function";
import { AlertService } from '../../services/alert.service';
import swal from 'sweetalert2';
declare const google: any;
var marker: any;
var map: any;
var cl: any;
var isLocCreated: boolean = false;
var lat: number;
var lng: number;



var originLngSection: number;
var originLatSection: number;
var destinationLatSection: number;
var destinationLngSection: number;


var originMarkerSection: any;
var destinationMarkerSection: any;
var isOriginCreatedSection: any;
var isDestinationCreatedSection: any;



var originMarker: any;
var destinationMarker: any;

var originMarkerSec: any;
var destinationMarkerSec: any;

var originMarkerSection2: any;
var destinationMarkerSection2: any;

var directionsService: any;
var directionsDisplay: any;

var directionsServiceSection: any;
var directionsDisplaySection: any;

var directionsServiceSection2: any;
var directionsDisplaySection2: any;

var map: any;

var originLng: number;
var destinationLng: number;



var originLat: number;
var destinationLat: number;

var arrCtrlPts: any = [];
var all_overlays: any = [];

var isOriginDestinationCreated: boolean = false;
var isOriginCreated: boolean = false;
var isDestinationCreated: boolean = false;
var isRouteCreated: boolean = false;
var isRouteCreatedSection: boolean = false;
var isOptionalRouteCreated: boolean = false;
import * as $ from 'jquery';


@Component({
  selector: 'app-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.css']
})
export class RateComponent implements OnInit {
  rate: any = {};
  // rate.name = '';
  rates: any = [];
  ratesMarkers: any = [];
  routes: any = [];
  pointsType: any = [];
  routetrace: any = {};
  data: any = {};
  wAux: any[] = [];
  wAuxSection: any[] = [];
  typerate: any = false
  /*public nombreRuta: string;
  public direccionOrigen: string;
  public direccionDestino: string;*/
  routeId: number = -1;
  temporalValue : any = 0
  
  public isPtCreated = false;
  public isValid = true;
  public isCollapsed = true;
  public rId = 0;
  public isDisable1 = true;
  public isDisable2 = true;
  public isDisable3 = true;
  public isFixedRate = true;
  public hiddeMap = true;
  public auxIdTypeRate = 1;
  public isTypeChanged = false;
  public isNew = true;
  public isVariableRate: any = false;
  public mapMarkerList : any = [];
  public selectedRoute : number;


  public configuringFestive = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private routesService: RoutesService,
    private routeService: RouteService,
    private rateService: RateService,
    private commonService: CommonService,
    private alertService: AlertService
  ) { }
  
  // ngAfterViewChecked(){
  //   this.isVariableRate = false;
  // } 

  ngOnInit() {
    this.getRoutes();
    this.typerate = false;
    this.rate.Name = '';
    console.log('this.rate.Name  : ', this.rate.Name)
    map = new google.maps.Map((<HTMLInputElement>document.getElementById('b-map')), {
      zoom: 7,
      center: new google.maps.LatLng(4.624335, -74.063644)
    });

    console.log((document.getElementById('buttonTracer')))
    console.log($("#originLocation"))

  }

  getSection(idRoute) {
    console.log('getSection ', idRoute)
  }



  addOriginPoint() {
    //if (!originLat || !originLng) return;
    var coordinate = new google.maps.LatLng(originLat, originLng);
    //create a marker
    console.log("aca")
    var infoWindowContent1 = '<div class="info_content">' +
      '<p> Ubicación: ' + (<HTMLInputElement>document.getElementById('originLocation')).value + '</p>' +
      '</div>';
    var infoWindow1 = new google.maps.InfoWindow({
      content: infoWindowContent1
    });
    var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/A/000080/");
    originMarker = new google.maps.Marker({
      position: coordinate,
      map: map,
      draggable: true,
      icon: pinImage,
    });
    google.maps.event.addListener(originMarker, 'click', function () {
      infoWindow1.open(map, originMarker);
    });
    google.maps.event.addListener(originMarker, 'dragend', function (marker) {
      var latLng = marker.latLng;
      originLat = latLng.lat();
      originLng = latLng.lng();
      //alert(originLat+" "+originLng);
    });
    isOriginCreated = true;
  }
  addDestinationPoint() {
    var coordinate = new google.maps.LatLng(destinationLat, destinationLng);
    //create a marker
    console.log("aca")
    var infoWindowContent2 = '<div class="info_content">' +
      '<p> Ubicación: ' + (<HTMLInputElement>document.getElementById('destinationLocation')).value + '</p>' +
      '</div>';
    var infoWindow2 = new google.maps.InfoWindow({
      content: infoWindowContent2
    });
    var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/B/999900/");
    destinationMarker = new google.maps.Marker({
      position: coordinate,
      icon: pinImage,
      map: map,
      draggable: true
    });
    google.maps.event.addListener(destinationMarker, 'click', function () {
      infoWindow2.open(map, destinationMarker);
    });
    google.maps.event.addListener(destinationMarker, 'dragend', function (marker) {
      var latLng = marker.latLng;
      destinationLat = latLng.lat();
      destinationLng = latLng.lng();
      //alert(destinationLat+" "+destinationLng);
    });
    isDestinationCreated = true;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async setPlaces() {
    // Espera hasta que se hacen visibles los elementos
    await this.delay(1000);

    console.log("sicas")

    var places1 = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('originLocation')));
    google.maps.event.addListener(places1, 'place_changed', () => {
    var place1 = places1.getPlace();

      var src_addr = place1.formatted_address;
      var src_lat = place1.geometry.location.lat();
      var src_long = place1.geometry.location.lng();
      originLat = src_lat;
      originLng = src_long;
      var mesg1 = "Address 1: " + src_addr;
      mesg1 += "\nLatitude: " + src_lat;
      mesg1 += "\nLongitude: " + src_long;
      this.addOriginPoint();
    });
    var places2 = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('destinationLocation')));
    google.maps.event.addListener(places2, 'place_changed', () => {
      var place2 = places2.getPlace();

      var src_addr = place2.formatted_address;
      var src_lat = place2.geometry.location.lat();
      var src_long = place2.geometry.location.lng();
      destinationLat = src_lat;
      destinationLng = src_long;
      var mesg2 = "Address 2: " + src_addr;
      mesg2 += "\nLatitude: " + src_lat;
      mesg2 += "\nLongitude: " + src_long;
      this.addDestinationPoint();
    });



    var places = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('location')));
    google.maps.event.addListener(places, 'place_changed', () => {
      var place = places.getPlace();

      var src_addr = place.formatted_address;
      var src_lat = place.geometry.location.lat();
      var src_long = place.geometry.location.lng();
      lat = src_lat;
      lng = src_long;
      if (this.isPtCreated == false) {
        this.createPt();
      } else {
        swal({
          title: 'Ya se ha creado una ubicación para la tarifa, debe borrar la ubicación actual para generar otra.',
          text: '',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Ok',
        }).then(function (s) {

        });
      }
    });
  }

  getRoutes(): void {
    this.routesService.getRoutesByUsername(this.commonService.getUserName()).then(response => {
      if (response) {
        this.routes = response;
        this.routes.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
          });
      }
    });
  }
  
  onSelectRoute(value): void {
    
    map = new google.maps.Map((<HTMLInputElement>document.getElementById('b-map')), {
      zoom: 7,
      center: new google.maps.LatLng(4.624335, -74.063644)
    });

    this.selectedRoute = value
    if (originMarker != null) {
      originMarker.setMap(null);
      originMarker = null;
    }
    if (destinationMarker != null) {
      destinationMarker.setMap(null);
      destinationMarker = null;
    }
    isOriginCreated = false;
    isDestinationCreated = false;
    if (marker != null) {
      marker.setMap(null);
      marker = null;
    }
    this.rate = {};
    originLat = null;
    originLng = null;
    destinationLat = null;
    destinationLng = null;
    this.isPtCreated = false;
    this.isTypeChanged = false;
    lat = null;
    lng = null;
    this.isNew = true;
    if (directionsDisplay != null) {
      directionsDisplay.setMap(null);
      directionsDisplay = null;
    }
    for (var i = 0; i < this.ratesMarkers.length; i++) {
      this.ratesMarkers[i].marker.setMap(null);
    }
    isRouteCreated = false;
    this.isFixedRate = true;
    this.wAux = [];
    this.rates = [];
    this.ratesMarkers = [];
    this.isDisable1 = true;
    this.isDisable2 = true;
    this.isDisable3 = false;
    this.rate.Id_TypeRate = 1;
    if (value != "0") {
      this.rId = value;
      this.routetrace.id = value;
      this.rate.Id_Route = value;
      this.loadRoute(value);
      this.getRates(value);
      // this.getSection(value);
    }
  }

  reloadSelectedRoute(value): void {
    if (originMarker != null) {
      originMarker.setMap(null);
      originMarker = null;
    }
    if (destinationMarker != null) {
      destinationMarker.setMap(null);
      destinationMarker = null;
    }
    isOriginCreated = false;
    isDestinationCreated = false;
    if (marker != null) {
      marker.setMap(null);
      marker = null;
    }
    this.rate = {};
    originLat = null;
    originLng = null;
    destinationLat = null;
    destinationLng = null;
    this.isPtCreated = false;
    this.isTypeChanged = false;
    lat = null;
    lng = null;
    this.isNew = true;
    if (directionsDisplay != null) {
      directionsDisplay.setMap(null);
      directionsDisplay = null;
    }
    for (var i = 0; i < this.ratesMarkers.length; i++) {
      this.ratesMarkers[i].marker.setMap(null);
    }
    isRouteCreated = false;
    this.isFixedRate = true;
    this.wAux = [];
    this.rates = [];
    this.ratesMarkers = [];
    this.isDisable1 = true;
    this.isDisable2 = true;
    this.isDisable3 = false;
    this.rate.Id_TypeRate = 1;
    if (value != "0") {
      this.rId = value;
      this.routetrace.id = value;
      this.rate.Id_Route = value;
      this.loadRoute(value);
      this.getRates(value);
      // this.getSection(value);
    }
  }
  
  loadRoute(idRoute) {
    var waypts = [];
    this.wAux = [];
    let that = this;
    this.routeService.getRoute(idRoute).then(response => {
      if (response) {
        this.routetrace = {};
        this.routetrace.id = response[0].id;
        this.routetrace.CustomName = response[0].name;

        var routeData = response[0].route_data;
        
        try {

          var str = routeData;
          var obj = JSON.parse(str);
          originLng = obj.origin.originLng;
          originLat = obj.origin.originLat;
          destinationLat = obj.destination.destinationLat;
          destinationLng = obj.destination.destinationLng;
          this.isDisable1 = false;
          if (obj.waypoints.length > 0) {// Ruta fija
            for (var i = 0; i < obj.waypoints.length; i++) {
              this.wAux[i] = [obj.waypoints[i][0], obj.waypoints[i][1]];
              waypts.push({
                location: new google.maps.LatLng(obj.waypoints[i][0], obj.waypoints[i][1]),
                stopover: true
              });
            }
            directionsService = new google.maps.DirectionsService();
            directionsDisplay = new google.maps.DirectionsRenderer({
              draggable: true,
              suppressMarkers: true
            });
            var req = {
              origin: new google.maps.LatLng(originLat, originLng),
              destination: new google.maps.LatLng(destinationLat, destinationLng),
              waypoints: waypts,
              optimizeWaypoints: true,
              travelMode: google.maps.DirectionsTravelMode.DRIVING
            };
            directionsDisplay.setMap(map);
            directionsService.route(req, function (response, status) {
              if (status === google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);
                if (originMarker != null) {
                  originMarker.setMap(null);
                  originMarker = null;
                }
                if (destinationMarker != null) {
                  destinationMarker.setMap(null);
                  destinationMarker = null;
                }
                var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
                var coordinateDestination = new google.maps.LatLng(destinationLat, destinationLng);
                originMarker = new google.maps.Marker({
                  position: coordinateOrigin,
                  map: map
                });
                var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/7d2181/");
                destinationMarker = new google.maps.Marker({
                  position: coordinateDestination,
                  icon: pinImage,
                  map: map
                });

              }
            });
            isRouteCreated = true;
            isOriginCreated = true;
            isDestinationCreated = true;
            map.setZoom(10);
            map.setCenter(new google.maps.LatLng(originLat, originLng));
          } else { // Ruta
            directionsService = new google.maps.DirectionsService();
            directionsDisplay = new google.maps.DirectionsRenderer({
              draggable: true,
              suppressMarkers: true
            });
            
            var request = {
              origin: new google.maps.LatLng(originLat, originLng),
              destination: new google.maps.LatLng(destinationLat, destinationLng),
              travelMode: google.maps.DirectionsTravelMode.DRIVING
            };

            directionsDisplay.setMap(map);
            directionsService.route(request, function (response, status) {
              if (status === google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);
                if (originMarker != null) {
                  originMarker.setMap(null);
                  originMarker = null;
                }
                if (destinationMarker != null) {
                  destinationMarker.setMap(null);
                  destinationMarker = null;
                }
                var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
                var coordinateDestination = new google.maps.LatLng(destinationLat, destinationLng);
                originMarker = new google.maps.Marker({
                  position: coordinateOrigin,
                  map: map
                });
                var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/7d2181/");
                destinationMarker = new google.maps.Marker({
                  position: coordinateDestination,
                  icon: pinImage,
                  map: map
                });

              }
            });
            map.setZoom(10);
            map.setCenter(new google.maps.LatLng(originLat, originLng));
            isRouteCreated = true;
            isOriginCreated = true;
            isDestinationCreated = true;
          }

        } catch (err) {

          swal({
            title: 'Primero debe trazar un trayecto para la ruta seleccionada.',
            text: '',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Trazar ruta',
            cancelButtonText: 'Volver'
          }).then(function (s) {

            if (s.dismiss !== undefined) {
              if (s.dismiss.toString() === 'cancel') {
              }
            } else {
              if (s.value !== undefined) {

                if (s.value) {
                  console.log('routing traceroute')
                  that.router.navigate(['/home/routetrace']);
                }
              }
            }
          });

          /*
        swal({
          title: "Primero debe trazar un trayecto para la ruta seleccionada.",
          // title: "No se ha trazado un trayecto para la ruta seleccionada.",
          text: '',
          type: 'warning'
         }).catch(swal.noop);   
                /*
          
          */
        }
      }
    });
  }

  traceRtn() {
    var col = '#' + ((1 << 24) * Math.random() | 0).toString(16);

    console.log('col : ', col)

    directionsService = new google.maps.DirectionsService();

    directionsDisplay = new google.maps.DirectionsRenderer({
      draggable: true,
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: '#DF3A01'
      }
    });

    var request = {
      origin: new google.maps.LatLng(originLat, originLng),
      destination: new google.maps.LatLng(destinationLat, destinationLng),
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsDisplay.setMap(map);

    directionsService.route(request, function (response, status) {
      if (status === google.maps.DirectionsStatus.OK) {

        directionsDisplay.setDirections(response);
        originMarker.setMap(null);
        destinationMarker.setMap(null);

        var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
        var coordinateDestination = new google.maps.LatLng(destinationLat, destinationLng);
        var pinImageOrigin = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/A/000080/");

        originMarker = new google.maps.Marker({
          position: coordinateOrigin,
          map: map,
          icon: pinImageOrigin,
        });
        var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/B/999900/");

        destinationMarker = new google.maps.Marker({
          position: coordinateDestination,
          icon: pinImage,
          map: map
        });

      }
    });
    isRouteCreated = true;

  }

  setPointInMap(coordinate, rate){
    var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/1ea362/");
    var m = new google.maps.Marker({
       position:coordinate,
       icon:pinImage,
       map: map
     });

     var infoWindowContent = '<div class="info_content">' +
                              '<p>Nombre: '+rate.name+'</p>' +
                              '<p>Tarifa: '+rate.rate+'</p>' +
                          '</div>';
     m.info = new google.maps.InfoWindow({
        content: infoWindowContent
     });
     console.log("va pasando")

     google.maps.event.addListener(m, 'click', function() {
       this.info.open(map, this);
     });
     
     console.log("si pasa")
     m.mID = rate.id;
     this.ratesMarkers.push({id:rate.id, marker:m});
     map.setZoom(10);
     map.setCenter(coordinate);
     
  }

  cleanMarkers(){
    console.log(this.mapMarkerList)
    for (var i = 0; i < this.mapMarkerList.length; i++) {
      try{
        var marker = this.mapMarkerList[i]
        marker.origin.setMap(null);
        marker.destination.setMap(null);
      }catch (e){

      }
    }
    this.mapMarkerList = []
  }

  paintTram(originLat, originLng, destinationLat, destinationLng, tramIndex) {
    var col = '#' + ((1 << 24) * Math.random() | 0).toString(16);
    var that = this

    console.log('col : ', col)

    var directionsService = new google.maps.DirectionsService();

    var directionsDisplay = new google.maps.DirectionsRenderer({
      draggable: true,
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: col
      }
    });

    var request = {
      origin: new google.maps.LatLng(originLat, originLng),
      destination: new google.maps.LatLng(destinationLat, destinationLng),
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsDisplay.setMap(map);

    directionsService.route(request, function (response, status) {
      if (status === google.maps.DirectionsStatus.OK) {

        directionsDisplay.setDirections(response);
        //originMarker.setMap(null);
        //destinationMarker.setMap(null);

        var iconUrl = "http://maps.google.com/mapfiles/kml/paddle/" + tramIndex + ".png"
        var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
        var coordinateDestination = new google.maps.LatLng(destinationLat, destinationLng);
        var pinImageOrigin = new google.maps.MarkerImage(iconUrl);

        originMarker = new google.maps.Marker({
          position: coordinateOrigin,
          map: map,
          icon: pinImageOrigin,
        });
        var pinImage = new google.maps.MarkerImage(iconUrl);

        destinationMarker = new google.maps.Marker({
          position: coordinateDestination,
          icon: pinImage,
          map: map
        });

        that.mapMarkerList.push({ origin: originMarker, destination: destinationMarker});
      }
    });
    isRouteCreated = true;

  }

  getRates(idRoute) {
    this.cleanMarkers()
    this.rateService.getRates(idRoute).then(response => {
      if (response) {
        try {
          // this.rate.Rate = response[0].rate;
          // this.rate.RateHoliday = response[0].rateHoliday;
          this.rates = response;
          

          if (response[0].id_typerate == 1) { // Ruta fija
            this.rate.Id = response[0].id;
            //this.rate.Name = response[0].name;
            this.rate.Id_TypeRate = response[0].id_typerate;
            this.rate.Rate = response[0].rate
            this.rate.RateHoliday = response[0].rateHoliday

            this.isDisable2 = true;
            this.isDisable3 = false;
            this.isFixedRate = true;
            this.hiddeMap = true;
            this.rate.typerate = false;
            this.auxIdTypeRate = 1;
            this.isNew = false;
            this.isVariableRate = false;
          } else { // Ruta variable
            this.rate.Id_TypeRate = 2;
            this.auxIdTypeRate = 2;
            this.rates = response;
            this.isDisable2 = false;
            this.isDisable3 = true;
            this.isFixedRate = false;
            this.hiddeMap = false;
            this.rate.typerate = true;
            this.isNew = false;
            this.isVariableRate = true;
            this.setPlaces()

            for (var i = 0; i < this.rates.length; i++) {
              var latitude = this.rates[i].latitude;
              var longitude = this.rates[i].longitude;
              
              var coordinate = new google.maps.LatLng(latitude, longitude);
              var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/1ea362/");
              var m = new google.maps.Marker({
                position:coordinate,
                icon:pinImage,
                map: map
              });

              var infoWindowContent = '<div class="info_content">' +
                                        ''+this.rates[i].name+'</p>' +
                                    '</div>';
              m.info = new google.maps.InfoWindow({
                  content: infoWindowContent
              });
              
              
              google.maps.event.addListener(m, 'click', function() {
                this.info.open(map, this);
              });
              
              
              map.setZoom(10);
              map.setCenter(coordinate);
              
              m.info.open(map,m)

              this.mapMarkerList.push(m)
              // var originLatit = latitude.split("_")[0]
              // var originLong = latitude.split("_")[1]

              // var destinationLatit = longitude.split("_")[0]
              // var destinationLong = longitude.split("_")[1]
              
              // var originCoordinate = new google.maps.LatLng(originLatit, originLong);
              // var destinCoordinate = new google.maps.LatLng(destinationLatit, destinationLong);
              // this.setPointInMap(originCoordinate, this.rates[i])
              // this.setPointInMap(destinCoordinate, this.rates[i])

              // this.paintTram(originLatit, originLong, destinationLatit, destinationLong, i+1)
            }

            //this.getRateRoutes(this.rates)
          }

          setTimeout(() => { // Espera que se carguen los inputs y les asigna el valor correspondiente
            for (const i in this.rates) {
              var startId = this.rates[i].id
              var valuesContainer =  $(".value_rate_"+this.rates[i].id)
              for(var j =0; j < valuesContainer.length; j++){
                
                var endId =  $(valuesContainer[j]).find("#rateEnd").val()
                console.log(startId)
                console.log(endId)
                
                for (let k = 0; k < this.rates[i].rate_values.length; k++) {
                  var value = this.rates[i].rate_values[k]
                  console.log(value)
                  if(value.start_rate_id == startId && value.end_rate_id == endId){
                    $(valuesContainer[j]).find("#valueinput").val(value.value)
                    $(valuesContainer[j]).find("#valueinput_festive").val(value.festive_value)
                  }                

                }

              }

            }
            
          }, 1000);

        } catch (err) { }
      }
    });
  }

  getRateRoutes(idRoute) {
    var contSection = 0;
    var wayptsSection = [];
    for (var i = 0; i < this.rates.length; i++) {
      console.log('i i i i ii i i i ii i ', i)
      var routeDataSection = this.rates[i].routeRate
      var strSection = routeDataSection;
      var objSection = JSON.parse(strSection);
      originLngSection = objSection.origin.originLng.toFixed(8);
      originLatSection = objSection.origin.originLat.toFixed(8);
      destinationLatSection = objSection.destination.destinationLat.toFixed(8);
      destinationLngSection = objSection.destination.destinationLng.toFixed(8);
      this.isDisable1 = false;
      var col = '';
      contSection = contSection + 1
      var coorOrigin = this.rates[i].latitude;
      var coorDestination = this.rates[i].longitude;
      var rateName = this.rates[i].name;
      var coordinatesOr = coorOrigin.split('_')
      var originLatSec = parseFloat(coordinatesOr[0])
      var originLngSec = parseFloat(coordinatesOr[1])
      var coordinatesDest = coorDestination.split('_')
      var destinationLatSec = parseFloat(coordinatesDest[0])
      var destinationLngSec = parseFloat(coordinatesDest[1])

      //region routepaint
      console.log('objSection.waypoints.length : ', objSection.waypoints.length)
      console.log('objSection.waypoints : ', objSection.waypoints)
      if (objSection.waypoints.length > 0) {
        console.log('ifffffffff')
        console.log('objSection : ', objSection)
        for (var w = 0; w < objSection.waypoints.length; w++) {
          this.wAux[w] = [objSection.waypoints[w][0], objSection.waypoints[w][1]];
          wayptsSection.push({
            location: new google.maps.LatLng(objSection.waypoints[w][0], objSection.waypoints[w][1]),
            stopover: true
          });
        }

        console.log('wayptsSection : ', wayptsSection)
        directionsServiceSection = new google.maps.DirectionsService();
        directionsDisplaySection = new google.maps.DirectionsRenderer({ draggable: true, suppressMarkers: true, polylineOptions: { strokeColor: '#DF3A01' } });
        var req = {
          origin: new google.maps.LatLng(originLatSec, originLngSec),
          destination: new google.maps.LatLng(destinationLatSec, destinationLngSec),
          waypoints: wayptsSection,
          optimizeWaypoints: true,
          travelMode: google.maps.DirectionsTravelMode.DRIVING
        };


        directionsDisplaySection.setMap(map);
        console.log('directionsDisplaySection : ', directionsDisplaySection)


        directionsServiceSection.route(req, function (response, status) {
          console.log('status  : ', status)
          console.log('google.maps.DirectionsStatus.OK  : ', google.maps.DirectionsStatus.OK)
          if (status === google.maps.DirectionsStatus.OK) {

            directionsDisplaySection.setDirections(response);
            if (originMarkerSection != null) {
              originMarkerSection.setMap(null);
              originMarkerSection = null;
            }
            if (destinationMarkerSection != null) {
              destinationMarkerSection.setMap(null);
              destinationMarkerSection = null;
            }
            var coordinateOriginSection = new google.maps.LatLng(originLatSec, originLngSec);
            var coordinateDestinationSection = new google.maps.LatLng(destinationLatSec, destinationLngSec);

            var pinImageOriginSection = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/A/000080/");
            var pinImageDestSection = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/B/999900/");
            originMarkerSection = new google.maps.Marker({ position: coordinateOriginSection, map: map, icon: pinImageOriginSection });
            destinationMarkerSection = new google.maps.Marker({ position: coordinateDestinationSection, icon: pinImageDestSection, map: map });
            var html = '<div class="info_content" style="border-radius:10px;"><p>Recorrido: 1' + rateName + ' </p></div>';
            destinationMarkerSection['infowindow'] = new google.maps.InfoWindow({ content: html });
            originMarkerSection['infowindow'] = new google.maps.InfoWindow({ content: html });
            google.maps.event.addListener(originMarkerSection, 'click', function () { this['infowindow'].open(map, this); });
            google.maps.event.addListener(destinationMarkerSection, 'click', function () { this['infowindow'].open(map, this); });
            map.setZoom(10);
            map.setCenter(coordinateOriginSection);


          }
        });



        isRouteCreated = true;
        isOriginCreated = true;
        isDestinationCreated = true;
        map.setZoom(10);
        map.setCenter(new google.maps.LatLng(originLatSec, originLngSec));
      }

      else {
        console.log('elseeeeeeeeeeeeee')
        directionsServiceSection2 = new google.maps.DirectionsService();
        directionsDisplaySection2 = new google.maps.DirectionsRenderer({ draggable: true, suppressMarkers: true, polylineOptions: { strokeColor: '#DF3A01' } });
        var request = {
          origin: new google.maps.LatLng(originLatSec, originLngSec),
          destination: new google.maps.LatLng(destinationLatSec, destinationLngSec),
          travelMode: google.maps.DirectionsTravelMode.DRIVING
        };
        directionsDisplaySection2.setMap(map);
        directionsServiceSection2.route(request, function (response, status) {
          if (status === google.maps.DirectionsStatus.OK) {
            directionsDisplaySection2.setDirections(response);
            if (originMarkerSection2 != null) {
              originMarkerSection2.setMap(null);
              originMarkerSection2 = null;
            }
            if (destinationMarkerSection2 != null) {
              destinationMarkerSection2.setMap(null);
              destinationMarkerSection2 = null;
            }
            var coordinateOriginSection2 = new google.maps.LatLng(originLatSec, originLngSec);
            var coordinateDestinationSection = new google.maps.LatLng(destinationLatSec, destinationLngSec);

            var pinImageOriginSection2 = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/A/000080/");
            var pinImageDestSection2 = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/B/999900/");
            originMarkerSection2 = new google.maps.Marker({ position: coordinateOriginSection2, map: map, icon: pinImageOriginSection2 });
            destinationMarkerSection2 = new google.maps.Marker({ position: coordinateDestinationSection, icon: pinImageDestSection2, map: map });
            var html = '<div class="info_content" style="border-radius:10px;"><p>Recorrido: 2' + rateName + ' </p></div>';
            destinationMarkerSection2['infowindow'] = new google.maps.InfoWindow({ content: html });
            originMarkerSection2['infowindow'] = new google.maps.InfoWindow({ content: html });
            google.maps.event.addListener(originMarkerSection2, 'click', function () { this['infowindow'].open(map, this); });
            google.maps.event.addListener(destinationMarkerSection2, 'click', function () { this['infowindow'].open(map, this); });
            map.setZoom(10);
            map.setCenter(coordinateOriginSection2);

          }
        });
        map.setZoom(10);
        map.setCenter(new google.maps.LatLng(destinationLatSec, destinationLngSec));
        // isRouteCreated = true;
        // isOriginCreated = true;
        // isDestinationCreated = true;

      }

      // end region routepaint

      /*
      var coordinateOriginSection = new google.maps.LatLng(originLatSec, originLngSec);
      var coordinateDestinationSection = new google.maps.LatLng(destinationLatSec, destinationLngSec);
      col = '#' + (( 1 << 24) * Math.random() | 0).toString(16);
      var pinImageOriginSection = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/A/000080/");                 
      var pinImageDestSection = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/B/999900/");
      originMarkerSection = new google.maps.Marker({position: coordinateOriginSection,map: map,icon:pinImageOriginSection});
      destinationMarkerSection = new google.maps.Marker({position: coordinateDestinationSection,Icon:pinImageDestSection,map: map});
      var html = '<div class="info_content" style="border-radius:10px;"><p>Recorrido: ' + rateName + ' </p></div>';
      destinationMarkerSection['infowindow'] = new google.maps.InfoWindow({content: html});
      originMarkerSection['infowindow'] = new google.maps.InfoWindow({content: html});
      google.maps.event.addListener(originMarkerSection, 'click', function() {this['infowindow'].open(map, this);});
      google.maps.event.addListener(destinationMarkerSection, 'click', function() {this['infowindow'].open(map, this);});
      map.setZoom(10);
      map.setCenter(coordinateOriginSection);
      */


    }
  }


  checkValue(event: any) {

    this.rate.Name = null;
    this.rate.Rate = null;
    this.rate.RateHoliday = null;
    this.rate.location = "";
    if (event) {
      this.isDisable2 = false;
      this.isDisable3 = true;
      this.isFixedRate = false;
      this.hiddeMap = false;
      if (this.isNew == false) {
        if (this.auxIdTypeRate != 2) {
          this.auxIdTypeRate = 2;
          this.isTypeChanged = true;
        } else {
          this.isTypeChanged = false;
        }
      }
      this.rate.Id_TypeRate = 2;
      this.rate.Id = 0

      this.isVariableRate = true;
      this.setPlaces()
    } else {
      this.isVariableRate = false;



      this.isDisable2 = true;
      this.isDisable3 = false;
      this.isFixedRate = true;
      this.hiddeMap = true;
      if (this.isNew == false) {
        if (this.auxIdTypeRate != 1) {
          this.auxIdTypeRate = 1;
          this.isTypeChanged = true;
        } else {
          this.isTypeChanged = false;
        }
      }
      this.rate.Id_TypeRate = 1;
    }
    console.log("cambio tipo:" + this.isTypeChanged);

    console.log('rate.typerate : ', this.rate.typerate)
  }

  checkValueFestive(event: any) {
    this.configuringFestive = !this.configuringFestive    
  }

  createPt() {
    console.log('creando')
    if (!lat || !lng) return;
    var coordinate = new google.maps.LatLng(originLat, originLng);
    if (marker) {
    }
    else {
      var infoWindowContent = '<div class="info_content">' +
        '<p> Nombre: ' + this.rate.Name + '</p>' +
        '<p> Tarifa: ' + this.rate.Rate + '</p>' +
        '</div>';
      var infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent
      });
      marker = new google.maps.Marker({
        position: coordinate,
        map: map,
        draggable: true
      });
      google.maps.event.addListener(marker, 'click', function () {
        infoWindow.open(map, marker);
      });
      google.maps.event.addListener(marker, 'dragend', function (marker) {
        var latLng = marker.latLng;
        lat = latLng.lat();
        lng = latLng.lng();
      });
      map.setZoom(15);
      map.setCenter(marker.getPosition());
      this.isPtCreated = true;
    }
  }

  savePt() {
    let that = this;
    
    swal({
      title: '¿Esta seguro de guardar la tarifa?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(function (s) {

      
      if(s.value){
        if(that.rate.Id_TypeRate == 1){// Tarifa unica
          if(that.rate.Rate == "" || that.rate.Rate == null){
            swal({
              title: 'Error!',
              text: 'Debe Proporcionar un valor para la Tarifa',
              type: 'warning',
            })
            return false
          }
  
          if(that.rate.RateHoliday == "" || that.rate.RateHoliday == null){
            swal({
              title: 'Error!',
              text: 'Debe Proporcionar un valor para la Tarifa Festiva',
              type: 'warning',
            })
            return false
          }
          that.rate.Name = ""
          // that.rateService.deleteRatesByRoute(that.rate.Id_Route)
          //           .then(response => {
          //           });
        }else{// Tarifa Variable
          if(that.rate.Name == "" || that.rate.Name == null){
            swal({
              title: 'Error!',
              text: 'Debe Proporcionar un nombre para la Tarifa',
              type: 'warning',
            })
            return false
          }
          that.rate.Rate = 0
          that.rate.RateHoliday = 0
          // that.rate.location = "1000"
        }

        that.rate.Latitude = originLat
        that.rate.Longitude = originLng
        
        console.log(that.rate)

        that.rateService.saveUpdateRate(that.rate)
          .then(response => {
            // this.getRates()
            if (response.status == 'EXITO') {
  
              that.onSelectRoute(that.selectedRoute)
              that.rate.Latitude = ""
              that.rate.Longitude = ""
              that.rate.Name = ""
              that.rate.originLocation = ""
              swal({
                title: response.message,
                text: '',
                type: 'success'
              }).catch(swal.noop);
            }
          });
      }

    });
  }


  savePtOld() {
    if (this.isFixedRate) {
      if (this.isTypeChanged) {
        var s = "";
        /*
        if(this.rate.Name ==null || this.rate.Name == ""){
          this.isValid=false;
          s=s+"El nombre es requerido";
        }
          */
        if (this.rate.Rate == null || this.rate.Rate == "") {
          if (this.isValid == false) {
            s = s + ", el valor de la tarifa es requerida";
          } else {
            s = s + "El valor de la tarifa es requerida";
          }
          this.isValid = false;

        }
        if (this.isValid) {
          let that = this;
          swal({
            title: '¿Esta seguro de guardar la tarifa?',
            text: '',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí',
            cancelButtonText: 'No'
          }).then(function (s) {

            if (s.dismiss !== undefined) {
              if (s.dismiss.toString() === 'cancel') {
              }
            } else {
              if (s.value !== undefined) {

                if (s.value) {
                  that.rateService.deleteRatesByRoute(that.rate.Id_Route)
                    .then(response => {
                      if (response.status == 'EXITO') {
                        /*if(originMarker!=null){
                             originMarker.setMap(null);
                             originMarker=null;
                          }
                        if(destinationMarker!=null){
                           destinationMarker.setMap(null);
                           destinationMarker=null;
                        }
                        isOriginCreated=false;
                        isDestinationCreated=false;*/
                        if (marker != null) {
                          marker.setMap(null);
                          marker = null;
                        }
                        /*originLat=null;
                        originLng=null;
                        destinationLat=null;
                        destinationLng=null;*/
                        that.isPtCreated = false;
                        lat = null;
                        lng = null;
                        /*if(directionsDisplay != null) {
                           directionsDisplay.setMap(null);
                           directionsDisplay = null;
                        }*/
                        for (var i = 0; i < that.ratesMarkers.length; i++) {
                          that.ratesMarkers[i].marker.setMap(null);
                        }
                        that.ratesMarkers = [];
                        that.rates = [];
                        that.isValid = true;

                        console.log('that.rate : ', that.rate)
                        var that2 = that
                        that.rateService.saveUpdateRate(that.rate)
                          .then(response => {

                            if (response.status == 'EXITO') {
                              if (response.lastId != 0) {
                                that.rate.Id = response.lastId;
                              }
                              that.isNew = false;
                              that.isTypeChanged = false;
                              that.rate.Name=null;
                              that.rate.Rate=null;

                              $("#originLocation").val("")
                              $("#destinationLocation").val("")
                              $("#name").val("")
                              swal({
                                title: response.message,
                                text: '',
                                type: 'success'
                              }).catch(swal.noop);
                            }
                          });
                      }
                    });
                }
              }
            }
          });
        } else {
          swal({
            title: s,
            text: '',
            type: 'warning'
          }).catch(swal.noop);
        }
      } else {
        console.log('variable')
        this.isValid = true;
        var s = "";
        // if(this.rate.Name ==null || this.rate.Name == ""){
        // this.isValid=false;
        // s=s+"El nombre es requerido";
        // }
        if (this.rate.Rate == null || this.rate.Rate == "") {
          if (this.isValid) {
            s = s + ", el valor de la tarifa es requerida";
          } else {
            s = s + "El valor de la tarifa es requerida";
          }
          this.isValid = false;

        }
        if (this.isValid) {
          let that = this;
          console.log('that.rate : ', that.rate)
          swal({
            title: '¿Esta seguro de guardar la tarifa?',
            text: '',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí',
            cancelButtonText: 'No'
          }).then(function (s) {

            if (s.dismiss !== undefined) {
              if (s.dismiss.toString() === 'cancel') {
              }
            } else {
              if (s.value !== undefined) {
                if (s.value) {
                  console.log('that.rate : ', that.rate)
                  that.rateService.saveUpdateRate(that.rate)
                    .then(response => {

                      if (response.status == 'EXITO') {
                        if (response.lastId != 0) {
                          that.rate.Id = response.lastId;
                        }
                        that.rate.Name=null;
                        that.rate.Rate=null;
                        that.rate.originLocation = null
                        that.rate.destinationLocation = null
                        that.rate.originLocation = ""
                        that.rate.destinationLocation = ""

                        that.isNew = false;

                        swal({
                          title: response.message,
                          text: '',
                          type: 'success'
                        }).catch(swal.noop);
                      }
                    });
                }
              }
            }
          });
        } else {
          swal({
            title: s,
            text: '',
            type: 'warning'
          }).catch(swal.noop);
        }
      }
    } else {
      this.isValid = true;
      var s = "";
      console.log(this.rate.Name);
      //if(this.rate.Name ==null || this.rate.Name == ""){
      // this.isValid=false;
      //s=s+"El nombre es requerido";
      //}
      if (this.rate.Rate == null || this.rate.Rate == "") {
        if (!this.isValid) {
          s = s + ", el valor de la tarifa es requerida";
        } else {
          s = s + "El valor de la tarifa es requerida";
        }
        this.isValid = false;
      }
      if (this.isValid) {
        //if(this.isPtCreated){
        let that = this;
        swal({
          title: '¿Esta seguro de guardar la tarifa?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
          cancelButtonText: 'No'
        }).then(function (s) {

          if (s.dismiss !== undefined) {
            if (s.dismiss.toString() === 'cancel') {
            }
          } else {
            if (s.value !== undefined) {
              if (s.value) {
                console.log('String(lat) :', String(lat))
                console.log('String(lng) : ', String(lng))

                console.log('String(originLat) : ', String(originLat))
                console.log('String(originLng) : ', String(originLng))

                console.log('String(destinationLat) : ', String(destinationLat))
                console.log('String(destinationLng) : ', String(destinationLng))



                // that.rate.Latitude = String(lat);
                // that.rate.Longitude = String(lng);


                that.rate.Latitude = String(originLat) + '_' + String(originLng);
                that.rate.Longitude = String(destinationLat) + '_' + String(destinationLng);


                var w = [], wp;
                var rleg = directionsDisplay.directions.routes[0].legs[0];
                that.data.origin = { 'originLat': originLat, 'originLng': originLng };
                that.data.destination = { 'destinationLat': destinationLat, 'destinationLng': destinationLng };
                var wp = rleg.via_waypoints;
                console.log(wp);
                console.log("---------");
                if (that.wAux.length == 0) {
                  for (var i = 0; i < wp.length; i++) {
                    w[i] = [wp[i].lat(), wp[i].lng()];
                  }
                } else {
                  for (var i = 0; i < that.wAux.length; i++) {
                    w[i] = [that.wAux[i][0], that.wAux[i][1]];
                  }
                  var j = that.wAux.length;
                  for (var i = 0; i < wp.length; i++) {
                    w[j] = [wp[i].lat(), wp[i].lng()];
                    j++;
                  }
                }
                console.log(w);
                that.data.waypoints = w;
                that.routetrace.Route_data = JSON.stringify(that.data);
                console.log(that.routetrace);
                var param = {
                  "Id": that.routetrace.id,
                  "Route_data": that.routetrace.Route_data
                };
                console.log(param);
                that.rate.RouteRate = that.routetrace.Route_data
                console.log('tht rate : ', that.rate)



                console.log(that.rate)
                that.rateService.saveUpdateRate(that.rate)
                  .then(response => {
                    // this.getRates()
                    if (response.status == 'EXITO') {

                      that.getRates(that.rate.Id_Route);

                      console.log(originLat)
                      console.log(originLng)
                      console.log("sicas")
                      var coordinate = new google.maps.LatLng(originLat, originLng);
                      var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/A/000080/");
                      var m = new google.maps.Marker({
                        position: coordinate,
                        icon: pinImage,
                        map: map
                      });
                      var infoWindowContent = '<div class="info_content">' +
                        '<p>Nombre: ' + that.rate.Name + '</p>' +
                        '<p>Tarifa: ' + that.rate.Rate + '</p>' +
                        '</div>';
                      m.info = new google.maps.InfoWindow({
                        content: infoWindowContent
                      });
                      google.maps.event.addListener(m, 'click', function () {
                        this.info.open(map, this);
                      });
                      m.mID = response.lastId;
                      //console.log(response.lastId);
                      //console.log(that.rate.Id);
                      if (response.lastId == 0) {
                        that.ratesMarkers.push({ id: that.rate.Id, marker: m });
                      } else {
                        that.ratesMarkers.push({ id: response.lastId, marker: m });
                      }
                      console.log(that.ratesMarkers);
                      map.setZoom(10);
                      map.setCenter(coordinate);
                      // marker.setMap(null);
                      // marker = null;
                      lat = null;
                      lng = null;
                      that.isPtCreated = false;
                      that.rate.Name = null;
                      that.rate.Rate = null;
                      that.rate.RateHoliday = null;
                      that.rate.location = "";
                      that.rate.originLocation = null
                      that.rate.destinationLocation = null
                      
                      
                      that.rate.Id = 0;
                      that.isNew = false;
                      var idRoute = that.rate.Id_Route;
                      that.rateService.getRates(idRoute).then(response => {
                        if (response) {
                          var len = response.length;
                          if (len > 0) {
                            that.rates = response;
                          }
                        }
                      });
                      swal({
                        title: response.message,
                        text: '',
                        type: 'success'
                      }).catch(swal.noop);
                    }
                  });
              }
            }
          }
        });
        // }else{
        // swal({
        //  title: "Debe de crear una ubicación para poder guardar.",
        //  text: '',
        //  type: 'warning'
        //  }).catch(swal.noop);
        // }
      } else {
        swal({
          title: s,
          text: '',
          type: 'warning'
        }).catch(swal.noop);
      }
    }
  }

  erasePt() {
    if (this.isPtCreated) {
      let that = this;
      swal({
        title: '¿Esta seguro de borrar el punto de control creado?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      }).then(function (s) {
        console.log(s);
        if (s.dismiss !== undefined) {
          if (s.dismiss.toString() === 'cancel') {
          }
        } else {
          if (s.value !== undefined) {
            if (s.value) {
              if (marker != null) {
                marker.setMap(null);
                marker = null;
              }
              that.isPtCreated = false;
              that.rate.name = "";
              that.rate.location = "";
              lat = null;
              lng = null;
            }
          }
        }
      }).catch(swal.noop);
    } else {
      swal({
        title: "Aún no se ha creado un punto de control.",
        text: '',
        type: 'warning'
      }).catch(swal.noop);
    }
  }
  removeRate(index) {
    var routeId = this.selectedRoute
    var id = index;
    console.log(id);
    let that = this;
    swal({
      title: '¿Esta seguro de borrar la tarifa seleccionada?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#ff5370',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(function (s) {
      console.log(s);
      if (s.dismiss !== undefined) {
        if (s.dismiss.toString() === 'cancel') {
        }
      } else {
        if (s.value !== undefined) {
          if (s.value) {
            that.rateService.deleteRate(id).then(response => {
              if (response) {
                that.onSelectRoute(that.selectedRoute)
                // if (response.status == 'EXITO') {
                //   that.rates.splice(index, 1);
                //   for (var i = 0; i < that.ratesMarkers.length; i++) {
                //     if (id == that.ratesMarkers[i].id) {
                //       that.ratesMarkers[i].marker.setMap(null);
                //       that.ratesMarkers.splice(i, 1);
                //     }
                //   }
                //   console.log(routeId)
                //   that.reloadSelectedRoute(routeId)
                //   swal({
                //     title: response.message,
                //     text: '',
                //     type: 'success'
                //   }).catch(swal.noop);
                // } else {
                // }
              }
            });
          }
        }
      }
    }).catch(swal.noop);
  }

  updateRate(id){
    var rateName = $("#namerate_"+id).val()
    console.log(rateName)

    var valueList = $(".value_rate_"+id)
    console.log(valueList)

    var rate_values = []
    for (let i = 0; i < valueList.length; i++) {
      const element = valueList[i];
      var endId = $(element).find("#rateEnd").val()
      var startId = id
      
      var value = $(element).find("#valueinput").val()
      var festive_value = $(element).find("#valueinput_festive").val()

      rate_values.push({ start_rate_id : startId, end_rate_id : endId, value : value, festive_value: festive_value})
    }
    console.log(rate_values)

    var data = {
      Id : id,
      Name : rateName,
      Rates_value : rate_values
    }

    this.rateService.updateRate(data).then(response => {
      if (response) {
        this.onSelectRoute(this.selectedRoute)
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/rate/rate.component.ts